import { AxiosResponse } from "axios";
import http from "utilities/http-common";

const baseUrl = "/api/EntityExpirationPeriod";


export function getEntityExpirationPeriods(tenantId?: string) {
    const params = new URLSearchParams();
    if (tenantId) {
        params.append("tenantId", tenantId);
    }

    return http
        .get(baseUrl, { params })
        .then((resp: AxiosResponse<EntityExpirationPeriod[]>) => {
            return resp.data;
    });
}

export function updateEntityExpirationPeriods(entityExpirationPeriod: EntityExpirationPeriod, tenantId?: string) {
    const params = new URLSearchParams();
    if (tenantId) {
        params.append("tenantId", tenantId);
    }
    
    return http
        .put(baseUrl, entityExpirationPeriod, { params })
        .then((resp: AxiosResponse<EntityExpirationPeriod>) => {
            return resp.data;
    });
  }